<template>
  <div class="page-publicDetail" id="page-publicDetail-id">
    <div class="publicDetail-content">
      <Breadcrumb :list="list" />
      <div class="d-title" v-html="publicDetail.infoTitle">
        <!-- {{ publicDetail.infoTitle }} -->
      </div>
      <div class="d-source-time">
        <div>
          <span v-if="publicDetail.publishTime">时间：{{ publicDetail.publishTime.split(' ')[0] }}</span>
          <span>来源：{{ publicDetail.infoSource }}</span>
        </div>
        <div id="info-detail-print-id">
          <img
            src="../../assets/image/print-icon.png"
            alt="打印"
            @click="handlePrint"
          />
          <span @click="handlePrint">打印</span>
          <img
            src="../../assets/image/share-icon.png"
            alt="分享"
            @click="handleShare"
          />
          <span @click="handleShare">分享</span>
        </div>
      </div>
      <div class="d-introduce" v-if="publicDetail.infoIntroduce">
        <h3>导语：</h3>
        <p>{{ publicDetail.infoIntroduce }}</p>
      </div>
      <!-- <div class="d-img" v-if="publicDetail.infoImg">
        <img :src="publicDetail.infoImg" alt="photo" @error="infoImgError" />
      </div> -->
      <div class="d-content" v-html="publicDetail.infoContent"></div>
      <div class="d-file" v-if="publicDetail.enclosure.length > 0">
        <div class="d-file-title">附件</div>
        <div
          class="d-file-files"
          v-for="(item, index) in publicDetail.enclosure"
          :key="item.name + index"
        >
          <a :href="item.downUrl" target="_blank">
            {{ `${index + 1}.${item.name}` }}
          </a>
        </div>
      </div>
      <div
        class="d-prev-next"
        id="info-detail-prev-next-id"
        v-if="
          Object.keys(prevData).length > 0 || Object.keys(nextData).length > 0
        "
      >
        <div v-if="Object.keys(prevData).length > 0">
          <span>上一篇</span>
          <span @click="toPrevOrNext(prevData.id)">
            {{ prevData.infoName }}
          </span>
        </div>
        <div v-if="Object.keys(nextData).length > 0">
          <span>下一篇</span>
          <span @click="toPrevOrNext(nextData.id)">
            {{ nextData.infoName }}
          </span>
        </div>
      </div>
      <div id="info-detail-top-id" class="to-top" @click="handleToTop">
        <img src="../../assets/image/to-top.png" alt="回到顶部" />
      </div>
    </div>
    <PublicShare ref="shareRef" />
  </div>
</template>
<script>
import * as API from '../../api/home/index'
import { classList } from '../publicInformationList/assets'
import Breadcrumb from '../../components/breadcrumb.vue'
import PublicShare from '../../components/publicShare.vue'
export default {
  name: 'PublicInformationDetail',
  components: { Breadcrumb, PublicShare },
  data() {
    const { classifyId = 1, id } = this.$route.query
    const { label, iconName } =
      classList.find((item) => item.value === Number(classifyId)) ?? {}
    return {
      id,
      classifyId,
      classList,
      list: [
        {
          label,
          path: classifyId < 6 ? '/publicInformationList' : `/careerMatrix/${classifyId}`,
          query: { }
        },
        {
          label: `${label}详情`,
          path: '/publicInformationDetail'
        }
      ],
      classifyName: label,
      classifyIcon: require(`../../assets/image/${iconName}`),
      publicDetail: { enclosure: [] },
      prevData: {},
      nextData: {}
    }
  },
  created() {
    this.defaultInit()
  },
  methods: {
    // 默认进入
    defaultInit() {
      this.getPublicDetail()
      this.getPublicList()
    },
    async getPublicDetail(resolveC = () => {}, rejectC = () => {}) {
      const { id } = this
      if (!id) return
      try {
        if (this.$route.query.name) {
          const res = await API.getDetailPublicES({ id: this.id, name: this.$route.query.name })
          const { code, data = {} } = res
          if (code === 0) {
            this.publicDetail = {
              ...data.content[0],
              enclosure: JSON.parse(data.content[0].enclosure)
            }
            resolveC(true)
          } else {
            throw Error()
          }
        } else {
          const res = await API.getDetailPublic({ id: this.id, name: this.$route.query.name })
          const { code, data = {} } = res
          if (code === 0) {
            this.publicDetail = {
              ...data,
              enclosure: JSON.parse(data.enclosure)
            }
            resolveC(true)
          } else {
            throw Error()
          }
        }
      } catch (error) {
        rejectC(false)
      }
    },
    async getPublicList() {
      const { classifyId, id: _thisId } = this
      if (!(classifyId && _thisId)) return
      try {
        const params = {
          page: 1,
          limit: -1,
          classifyId
        }
        const res = await API.getListPublic(params)
        const {
          code,
          data: { records = [] }
        } = res
        if (code === 0) {
          for (let i = 0; i < records.length; i++) {
            const { id } = records[i]
            if (id === _thisId) {
              if (i !== 0) {
                this.prevData = {
                  id: records[i - 1]?.id,
                  infoName: records[i - 1]?.infoName
                }
              } else {
                this.prevData = {}
              }
              if (i !== records.length - 1) {
                this.nextData = {
                  id: records[i + 1]?.id,
                  infoName: records[i + 1]?.infoName
                }
              } else {
                this.nextData = {}
              }
              break
            }
          }
        }
      } catch (error) {}
    },
    handleToTop() {
      document.documentElement.scrollTop = 0
    },
    toPrevOrNext(id) {
      this.id = id
      const { classifyId } = this
      window.history.replaceState(
        { classifyId, id },
        '',
        `?classifyId=${classifyId}&id=${id}`
      )
      // chrome
      document.body.scrollTop = 0
      // firefox
      document.documentElement.scrollTop = 0
      // safari
      window.pageYOffset = 0
      this.getPublicDetail()
      this.getPublicList()
    },
    handlePrint() {
      window.print()
    },
    handleShare() {
      const { classifyId, id } = this
      this.$refs.shareRef.handleShare('publicInformationDetailMobile', {
        classifyId,
        id,
        hideHeader: true,
        hideFooter: true
      })
    },
    infoImgError() {
      this.$set(this.publicDetail, 'infoImg', null)
    }
  }
}
</script>
<style lang="scss" scoped>
.page-publicDetail {
  padding: 28px 0 88px 0;
  background: #eef3ff;

  .publicDetail-content {
    width: 1200px;
    margin: 0 auto;
    background: #fff;
    padding-bottom: 107px;
    position: relative;
    .to-top {
      position: absolute;
      right: -92px;
      bottom: 30px;
      width: 64px;
      height: 64px;
      background: rgba($color: #000000, $alpha: 0.1);
      border-radius: 32px;
      cursor: pointer;
      > img {
        width: 100%;
        height: 100%;
      }
    }
    .d-title {
      margin: 20px auto 49px;
      // font-size: 36px;
      // font-family: Microsoft YaHei;
      // font-weight: bold;
      // color: #0853b6;
      text-align: center;
      white-space: pre-line
    }
    .d-source-time {
      width: 1127px;
      height: 56px;
      background: rgba($color: #000000, $alpha: 0.1);
      margin: 0 auto 41px;
      line-height: 56px;
      display: flex;
      justify-content: space-between;
      > div:first-child {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        > span:first-child {
          margin: 0 20px 0 61px;
        }
      }
      > div:last-child {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #0854b6;
        > img {
          width: 24px;
          height: 24px;
          vertical-align: middle;
          margin-right: 10px;
          cursor: pointer;
        }
        > span {
          margin-right: 35px;
          cursor: pointer;
        }
      }
    }
    .d-introduce {
      width: 1126px;
      height: 142px;
      background: #f2f2f2;
      margin: 0 auto 40px;
      box-sizing: border-box;
      padding: 30px 50px;
      > h3 {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
        margin-bottom: 20px;
      }
      > p {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 24px;
      }
    }
    .d-img {
      text-align: center;
      margin: 0 auto 58px;
      img {
        max-width: 100%;
      }
    }
    .d-content {
      width: 1024px;
      margin: 0 auto 49px;
    }
    .d-file {
      margin: 0 0 118px 88px;
      .d-file-title {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        text-decoration: underline;
        color: #333333;
        margin-bottom: 10px;
      }
      .d-file-files {
        margin-bottom: 10px;
        > a {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          text-decoration: underline;
          color: #0e2cf8;
          cursor: pointer;
        }
      }
    }
    .d-prev-next {
      width: 1126px;
      height: 109px;
      background: #f2f2f2;
      margin: 0 auto;
      box-sizing: border-box;
      padding: 21px 0 21px 57px;
      > div {
        > span:first-child {
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #333333;
          margin-right: 30px;
        }
        > span:last-child {
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 600;
          color: #0853b6;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
